var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"touchstart":_vm.handleTouch,"touchend":_vm.handleTouch}},[(!_vm.disableNumbArea)?_c('div',{staticClass:"numbarea"}):_vm._e(),_vm._v(" "),_vm._l((_vm.chars.split(',')),function(char){return _c('a',{attrs:{"data-char":char}},[_c('a',[_vm._v(_vm._s(char))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21aa761e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/strip-block-custom??ref--0-0!./src/components/CharKeyboard.vue
// module id = 2486
// module chunks = 1806 1815 1818 1820 1825 1826 1827 1828